"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMasonryShovel2 = function IconMasonryShovel2(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M38.219 6.287 15.7 13.366a3.512 3.512 0 0 0-1.405 5.833l7 7-.012.014-.001.001-4.916 4.916 1.414 1.414 4.93-4.93 7.003 7.003a3.51 3.51 0 0 0 5.829-1.4l7.082-22.527a3.51 3.51 0 0 0-4.406-4.403M24.124 26.2l7.006 7.005a1.51 1.51 0 0 0 2.506-.595l7.08-22.522a1.51 1.51 0 0 0-.371-1.523l-.114-.102a1.51 1.51 0 0 0-1.411-.27l-22.514 7.079a1.51 1.51 0 0 0-.599 2.51l7.003 7.004 2.823-2.823a1 1 0 0 1 1.497 1.32l-.083.094-.713.713zM13.5 29.76l-1.42 1.41-5.65 5.65a4.002 4.002 0 0 0 5.66 5.66l5.65-5.65 1.41-1.42L17.74 34l-2.83-2.83zm0 2.82 2.83 2.83-5.66 5.65a2 2 0 0 1-2.82 0 2 2 0 0 1 0-2.82z",
    clipRule: "evenodd"
  })));
};

export { IconMasonryShovel2, IconMasonryShovel2 as default };
